#import "./TrainingComplianceCellFields.graphql"

query GetTrainingEmployeeDetail($employeeId: ID!) {
  trainingEmployeeDetail(employeeId: $employeeId) {
    employeeId
    name
    email
    team {
      id
      name
    }
    startDate
    trainingRequired
    overall
    accessStatus
    cells {
      ...TrainingComplianceCellFields
    }
    assignments {
      id
      moduleId
      moduleTitle
      source
      assignedOn
      dueOn
      maxWatchPercent
      videoCompletedAt
      attemptsCount
      bestScore
      passedAt
      expiresOn
      exemptedAt
      exemptReason
    }
    quizAttempts {
      id
      assignmentId
      moduleTitle
      startedAt
      submittedAt
      abandonedAt
      score
      questionCount
      passed
    }
    policyAcknowledgements {
      id
      policyId
      policyTitle
      version
      acknowledgedAt
      source
    }
  }
}
